<div class="blank">
  <div class="noData">
    <span class="blank_img">
      <fa-icon [icon]="faChartMixed"></fa-icon>

      <div>
        Drag a chart into the
        {{ type }} from the left<br /><i>(or search for an existing chart)</i>
      </div>
    </span>
  </div>
</div>
